<app-info-modal class="info-modal-thanks-for-contacting" [infoModalData]="infoModalData"></app-info-modal>
